'use client';

import { PropsWithChildren } from 'react';
import { RichTextContent } from '../../../../RichText';
import GlassOverlay from '../overlay/GlassOverlay';
import ConfirmationMessage from './ConfirmationMessage';

type Props = {
  active: boolean;
  message?: RichTextContent;
  onClose: () => void;
};

/**
 * Shows the confirmation message over the form once it was submitted without
 * a redirect, until the visitor dismisses it. Renders the children untouched
 * when no message is configured.
 */
const FormConfirmationOverlay = ({
  active,
  message,
  onClose,
  children,
}: PropsWithChildren<Props>) => {
  if (!message) return children;

  return (
    <GlassOverlay
      active={active}
      overlay={<ConfirmationMessage message={message} onClose={onClose} />}
    >
      {children}
    </GlassOverlay>
  );
};

export default FormConfirmationOverlay;
